import { DatastoreInterface } from '@freelancer/datastore/core';
import { ReferralInvitationCheck } from './referral-invitation-check.model';
import { ReferralInvitationCheckCollection } from './referral-invitation-check.types';

interface GenerateReferralInvitationCheckOptions {
  readonly userId: number;
}

export async function createReferralInvitationCheck(
  datastore: DatastoreInterface,
  options: GenerateReferralInvitationCheckOptions,
) {
  const object = generateReferralInvitationCheckObject(options);
  await datastore.createRawDocument<ReferralInvitationCheckCollection>(
    'referralInvitationCheck',
    object,
  );
  return object;
}

function generateReferralInvitationCheckObject({
  userId,
}: GenerateReferralInvitationCheckOptions): ReferralInvitationCheck {
  return {
    id: userId.toString(),
    isEligible: true,
  };
}
